
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("f9opb", function(module, exports) {
/**
 * @generated SignedSource<<6ae68c3fc7cff269909f099f03ffeaf8>>
 * @relayHash 286c2a0ccfe96ab3b0fb682ebc3b94a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d2738c7d165a79a85d7a071def6710f780c53aee70da1e50b6e4616d3070225a
const $9ba28f7bc5b6ec04$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "autohighlightsEntityAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "autohighlightsWorkspaceId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "bylineContributorsLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAgentTrustReceiptData"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAnalyticsByline"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAudioContent"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAutohighlights"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAutomationDiscoveries"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeBylineContributors"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeClassification"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentHeader"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentHeaderAccess"
    }, v13 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentHeaderPublicLink"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFabricEditorEligibility"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeReactions"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRendererAssetsDsp"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRendererAssetsMedia"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRestrictionAncestors"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRestrictions"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSSR"
    }, v21 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "preloadLabels"
    }, v22 = {
        "defaultValue": "PAGE_EXPORT",
        "kind": "LocalArgument",
        "name": "rendererAssetsDspAction"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v24 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useContentModeFragment"
    }, v25 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v26 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v27 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v28 = [
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v29 = {
        "kind": "ScalarField",
        "name": "id"
    }, v30 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "type"
    }, v32 = {
        "kind": "ScalarField",
        "name": "status"
    }, v33 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v34 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": v33 /*: any*/ 
            },
            {
                "concreteType": "DraftContentProperties",
                "kind": "LinkedField",
                "name": "draft",
                "plural": false,
                "selections": v33 /*: any*/ 
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "name"
    }, v36 = {
        "kind": "ScalarField",
        "name": "color"
    }, v37 = {
        "args": [
            {
                "kind": "Literal",
                "name": "isDraft",
                "value": false
            }
        ],
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "contentState",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v35 /*: any*/ ,
            v36 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "restrictionLevel"
            }
        ],
        "storageKey": "contentState(isDraft:false)"
    }, v38 = {
        "kind": "ScalarField",
        "name": "value"
    }, v39 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "USER_FRIENDLY"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "contentStateLastUpdated",
        "plural": false,
        "selections": [
            v38 /*: any*/ 
        ],
        "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
    }, v40 = {
        "kind": "ScalarField",
        "name": "title"
    }, v41 = {
        "kind": "ScalarField",
        "name": "key"
    }, v42 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v35 /*: any*/ ,
            v41 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v43 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v44 = [
        v41 /*: any*/ ,
        v38 /*: any*/ 
    ], v45 = {
        "alias": "smartFolderProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": v44 /*: any*/ 
            }
        ],
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v46 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v47 = {
        "kind": "ScalarField",
        "name": "number"
    }, v48 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v49 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v50 = [
        v49 /*: any*/ 
    ], v51 = {
        "kind": "LinkedField",
        "name": "by",
        "plural": false,
        "selections": v50 /*: any*/ 
    }, v52 = {
        "kind": "ScalarField",
        "name": "when"
    }, v53 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v54 = [
        {
            "kind": "ScalarField",
            "name": "coverPictureWidth"
        }
    ], v55 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "embedded"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "collabService"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v54 /*: any*/ 
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "representation"
    }, v57 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            v47 /*: any*/ 
        ]
    }, v58 = {
        "concreteType": "WebResourceTags",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "js"
            },
            {
                "kind": "ScalarField",
                "name": "css"
            }
        ]
    }, v59 = [
        v58 /*: any*/ 
    ], v60 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "dynamic",
                "plural": false,
                "selections": [
                    v56 /*: any*/ ,
                    v38 /*: any*/ ,
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            v29 /*: any*/ ,
                            v57 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "WebResourceDependencies",
                        "kind": "LinkedField",
                        "name": "webresource",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "SuperBatchWebResources",
                                "kind": "LinkedField",
                                "name": "superbatch",
                                "plural": false,
                                "selections": v59 /*: any*/ 
                            },
                            v58 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v61 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v29 /*: any*/ ,
                v41 /*: any*/ ,
                v38 /*: any*/ ,
                v57 /*: any*/ 
            ]
        }
    ], v62 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v61 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v63 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "cover-picture-id-published",
                    "emoji-title-published",
                    "editor",
                    "import-source",
                    "imported-page-modified-date"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v61 /*: any*/ ,
        "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
    }, v64 = {
        "alias": "pageTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "page-title-property-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v61 /*: any*/ ,
        "storageKey": "properties(key:\"page-title-property-published\")"
    }, v65 = {
        "alias": "pageTitleDraft",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "page-title-property-draft"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v61 /*: any*/ ,
        "storageKey": "properties(key:\"page-title-property-draft\")"
    }, v66 = {
        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
        "kind": "LinkedField",
        "name": "frontend",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v67 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            v66 /*: any*/ 
        ]
    }, v68 = {
        "alias": "coverPictureProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "cover-picture-id-draft",
                    "cover-picture-id-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v61 /*: any*/ ,
        "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
    }, v69 = {
        "kind": "ScalarField",
        "name": "hasInheritedRestrictions"
    }, v70 = {
        "kind": "ScalarField",
        "name": "hasRestrictions"
    }, v71 = {
        "kind": "ScalarField",
        "name": "hasViewRestrictions"
    }, v72 = [
        {
            "kind": "Literal",
            "name": "orderBy",
            "value": {
                "direction": "ASCENDING",
                "sortField": "LABELLING_CREATIONDATE"
            }
        }
    ], v73 = {
        "kind": "ScalarField",
        "name": "count"
    }, v74 = {
        "kind": "ScalarField",
        "name": "label"
    }, v75 = {
        "kind": "ScalarField",
        "name": "prefix"
    }, v76 = {
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "contentReactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    v73 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    },
                    v29 /*: any*/ 
                ]
            }
        ]
    }, v77 = [
        {
            "kind": "Literal",
            "name": "key",
            "value": "emoji-title-published"
        }
    ], v78 = {
        "alias": "emoji",
        "args": v77 /*: any*/ ,
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v29 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v79 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v80 = [
        v49 /*: any*/ ,
        v79 /*: any*/ 
    ], v81 = {
        "kind": "ScalarField",
        "name": "webui"
    }, v82 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            v81 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v83 = {
        "alias": "audioProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v38 /*: any*/ ,
                    v41 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
    }, v84 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v29 /*: any*/ ,
            v40 /*: any*/ ,
            v70 /*: any*/ ,
            {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    v81 /*: any*/ 
                ]
            }
        ]
    }, v85 = {
        "concreteType": "ClassificationLevelDetails",
        "kind": "LinkedField",
        "name": "classificationLevelDetails",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentDataClassificationLevel",
                "kind": "LinkedField",
                "name": "classificationLevel",
                "plural": false,
                "selections": [
                    v29 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "guideline"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "guidelineADF"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v36 /*: any*/ ,
                    v35 /*: any*/ ,
                    v32 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "featureEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "source"
            },
            {
                "kind": "ScalarField",
                "name": "isReclassificationPermitted"
            },
            {
                "kind": "ScalarField",
                "name": "canManageSpaceSettings"
            },
            {
                "kind": "ScalarField",
                "name": "classificationControlSetting"
            },
            {
                "kind": "ScalarField",
                "name": "userOverrideSetting"
            }
        ]
    }, v86 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v87 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v88 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v89 = {
        "kind": "ScalarField",
        "name": "themeKey"
    }, v90 = {
        "kind": "ScalarField",
        "name": "background"
    }, v91 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v92 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v93 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v94 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v95 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v96 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v97 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v98 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v99 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v100 = {
        "concreteType": "ScreenLookAndFeel",
        "kind": "LinkedField",
        "name": "screen",
        "plural": false,
        "selections": [
            v90 /*: any*/ ,
            v91 /*: any*/ ,
            v92 /*: any*/ ,
            v93 /*: any*/ ,
            v94 /*: any*/ ,
            v95 /*: any*/ ,
            v96 /*: any*/ ,
            v97 /*: any*/ ,
            v98 /*: any*/ ,
            v99 /*: any*/ ,
            {
                "concreteType": "LayerScreenLookAndFeel",
                "kind": "LinkedField",
                "name": "layer",
                "plural": false,
                "selections": [
                    v90 /*: any*/ ,
                    v91 /*: any*/ ,
                    v92 /*: any*/ ,
                    v93 /*: any*/ ,
                    v94 /*: any*/ ,
                    v95 /*: any*/ ,
                    v96 /*: any*/ ,
                    v97 /*: any*/ ,
                    v98 /*: any*/ ,
                    v99 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "width"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "height"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "gutterTop"
            },
            {
                "kind": "ScalarField",
                "name": "gutterRight"
            },
            {
                "kind": "ScalarField",
                "name": "gutterBottom"
            },
            {
                "kind": "ScalarField",
                "name": "gutterLeft"
            }
        ]
    }, v101 = {
        "kind": "ScalarField",
        "name": "padding"
    }, v102 = {
        "kind": "ScalarField",
        "name": "borderRadius"
    }, v103 = {
        "concreteType": "ContainerLookAndFeel",
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v90 /*: any*/ ,
            v91 /*: any*/ ,
            v92 /*: any*/ ,
            v93 /*: any*/ ,
            v94 /*: any*/ ,
            v95 /*: any*/ ,
            v96 /*: any*/ ,
            v97 /*: any*/ ,
            v98 /*: any*/ ,
            v99 /*: any*/ ,
            v101 /*: any*/ ,
            v102 /*: any*/ 
        ]
    }, v104 = {
        "concreteType": "SpaceSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "routeOverrideEnabled"
            }
        ]
    }, v105 = {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isAnonymouslyAuthorized"
            }
        ]
    }, v106 = {
        "condition": "includeRendererAssetsMedia",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "MediaConfiguration",
                "kind": "LinkedField",
                "name": "mediaConfiguration",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "clientId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "fileStoreUrl"
                    }
                ]
            }
        ]
    }, v107 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v108 = {
        "condition": "includeRendererAssetsDsp",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Confluence_dataSecurityPolicy",
                "kind": "LinkedField",
                "name": "dataSecurityPolicy",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "action",
                                "variableName": "rendererAssetsDspAction"
                            },
                            v107 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "contentStatus",
                                "value": "CURRENT"
                            },
                            {
                                "kind": "Literal",
                                "name": "contentVersion",
                                "value": 1
                            },
                            {
                                "kind": "Variable",
                                "name": "spaceKey",
                                "variableName": "spaceKey"
                            }
                        ],
                        "concreteType": "DataSecurityPolicyDecision",
                        "kind": "LinkedField",
                        "name": "isActionEnabledForContent",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "action"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "allowed"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v109 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "autohighlightsEntityAri"
        },
        {
            "kind": "Variable",
            "name": "workspaceId",
            "variableName": "autohighlightsWorkspaceId"
        }
    ], v110 = [
        v107 /*: any*/ 
    ], v111 = {
        "condition": "includeContentHeaderPublicLink",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "contentId"
                    }
                ],
                "concreteType": "PublicLinkPage",
                "kind": "LinkedField",
                "name": "publicLinkPage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "pageId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "pageStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accessType"
                    }
                ]
            }
        ]
    }, v112 = [
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "bylineContributorsLimit"
        }
    ], v113 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v114 = [
        v113 /*: any*/ ,
        v49 /*: any*/ 
    ], v115 = {
        "kind": "LinkedField",
        "name": "by",
        "plural": false,
        "selections": v114 /*: any*/ 
    }, v116 = {
        "kind": "ScalarField",
        "name": "sourceTemplateEntityId"
    }, v117 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v118 = [
        v113 /*: any*/ ,
        v31 /*: any*/ ,
        v49 /*: any*/ ,
        v117 /*: any*/ ,
        v79 /*: any*/ 
    ], v119 = [
        v69 /*: any*/ ,
        v70 /*: any*/ ,
        v71 /*: any*/ 
    ], v120 = [
        v113 /*: any*/ ,
        v49 /*: any*/ ,
        v79 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentBlogUnifiedQuery",
            "selections": [
                {
                    "args": v28 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v29 /*: any*/ ,
                                v30 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                v34 /*: any*/ ,
                                v37 /*: any*/ ,
                                v39 /*: any*/ ,
                                v40 /*: any*/ ,
                                v42 /*: any*/ ,
                                v43 /*: any*/ ,
                                v45 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v46 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v48 /*: any*/ ,
                                        v51 /*: any*/ ,
                                        v52 /*: any*/ ,
                                        v53 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": [
                                        v46 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v48 /*: any*/ ,
                                        v51 /*: any*/ ,
                                        v52 /*: any*/ 
                                    ]
                                },
                                v55 /*: any*/ ,
                                v60 /*: any*/ ,
                                v62 /*: any*/ ,
                                v63 /*: any*/ ,
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ViewPageCommentsPanelPermission_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "commentsPanelPermission"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "PageStatusQueryRelaySpike_content"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "PresenterModePortal_content"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ArchivedPageBannerV2Status_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "archivedPageBannerStatusFragment"
                                },
                                {
                                    "condition": "useContentModeFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ContentModeFragmentProvider_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "viewPageContentMode"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeBylineContributors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "useNewContentTopper",
                                                                "variableName": "useNewContentTopper"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "ContentTitleWithByLine_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentTitleWithByLine"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "useTitleContentPropertiesForPublishedPage_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "rendererTitleContentProperties"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "CoverPictureQuery_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "rendererCoverPicture"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeAutomationDiscoveries",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "MeetingNotesAutomationDiscoveryFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "meetingNotesAutomationDiscoveryFragment"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeContentHeader",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "includeAccessButton",
                                                                "variableName": "includeContentHeaderAccess"
                                                            },
                                                            {
                                                                "kind": "Variable",
                                                                "name": "includeFabricEditorEligibility",
                                                                "variableName": "includeFabricEditorEligibility"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "ContentHeader_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentHeaderFragment"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useNewContentTopper",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v29 /*: any*/ ,
                                                    v64 /*: any*/ ,
                                                    v65 /*: any*/ ,
                                                    v67 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "titleContentProperties"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v29 /*: any*/ ,
                                                    v68 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "coverPicture"
                                        },
                                        v64 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeRestrictions",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v29 /*: any*/ ,
                                                    v69 /*: any*/ ,
                                                    v70 /*: any*/ ,
                                                    v71 /*: any*/ ,
                                                    v40 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "shareAndRestrictButtonData"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v29 /*: any*/ ,
                                                    v69 /*: any*/ ,
                                                    v71 /*: any*/ ,
                                                    v70 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "pageRestrictionsContext"
                                        }
                                    ]
                                },
                                {
                                    "condition": "preloadLabels",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ViewPageLabelsContentFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "viewPageLabels"
                                        },
                                        {
                                            "args": v72 /*: any*/ ,
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                v73 /*: any*/ ,
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v29 /*: any*/ ,
                                                        v74 /*: any*/ ,
                                                        v35 /*: any*/ ,
                                                        v75 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeReactions",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v29 /*: any*/ ,
                                                    v76 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "reactionsContent"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ReactionsContentFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "reactionsContentFragment"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeAudioContent",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v29 /*: any*/ ,
                                                    v40 /*: any*/ ,
                                                    v43 /*: any*/ ,
                                                    v78 /*: any*/ ,
                                                    {
                                                        "concreteType": "History",
                                                        "kind": "LinkedField",
                                                        "name": "history",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "createdBy",
                                                                "plural": false,
                                                                "selections": v80 /*: any*/ 
                                                            },
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "ownedBy",
                                                                "plural": false,
                                                                "selections": v80 /*: any*/ 
                                                            }
                                                        ]
                                                    },
                                                    v82 /*: any*/ ,
                                                    v83 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "audioContent"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "AudioContentFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "audioContentFragment"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeRestrictionAncestors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v29 /*: any*/ ,
                                                    v84 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "pageRestrictionsContextAncestors"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "BylineClassification_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "bylineClassificationFragment"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "useContentClassification_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentClassificationFragment"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v29 /*: any*/ ,
                                                    v85 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentClassification"
                                        }
                                    ]
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PageContentRenderer_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "pageContentRendererFragment"
                                },
                                {
                                    "condition": "includeAgentTrustReceiptData",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v86 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v50 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v87 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeRendererAssetsMedia",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "rendererAssetsMedia"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isSSR",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ViewPageExtensionsAndRendererAssetsContentFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "rendererAssetsMacroOutput"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v88 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeContentHeader",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ContentHeader_space"
                                            }
                                        ],
                                        "type": "Space"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentHeaderFragment"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ContentContainerTheme_space"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ContentTitle_space"
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "PageContentRenderer_space"
                                    }
                                ],
                                "type": "Space"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "pageContentRendererFragment"
                        },
                        v29 /*: any*/ ,
                        {
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "theme",
                            "plural": false,
                            "selections": [
                                v89 /*: any*/ ,
                                v35 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v100 /*: any*/ ,
                                        v103 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v104 /*: any*/ ,
                        v105 /*: any*/ 
                    ]
                },
                v106 /*: any*/ ,
                v108 /*: any*/ ,
                {
                    "condition": "includeAutohighlights",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v109 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "preloadAutohighlightsQuery_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "autohighlightsQueryFragment"
                        }
                    ]
                },
                {
                    "condition": "includeAnalyticsByline",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v110 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "AnalyticsByLine_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "analyticsBylineFragment"
                        }
                    ]
                },
                v111 /*: any*/ ,
                {
                    "condition": "includeBylineContributors",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v112 /*: any*/ ,
                            "concreteType": "ContentContributors",
                            "kind": "LinkedField",
                            "name": "contentContributors",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ByLineContributors_contentContributors"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v23 /*: any*/ ,
                v26 /*: any*/ ,
                v20 /*: any*/ ,
                v17 /*: any*/ ,
                v16 /*: any*/ ,
                v22 /*: any*/ ,
                v25 /*: any*/ ,
                v21 /*: any*/ ,
                v4 /*: any*/ ,
                v9 /*: any*/ ,
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                v15 /*: any*/ ,
                v19 /*: any*/ ,
                v18 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v14 /*: any*/ ,
                v13 /*: any*/ ,
                v5 /*: any*/ ,
                v24 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentBlogUnifiedQuery",
            "selections": [
                {
                    "args": v28 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v29 /*: any*/ ,
                                v30 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                v40 /*: any*/ ,
                                v63 /*: any*/ ,
                                v34 /*: any*/ ,
                                v37 /*: any*/ ,
                                v39 /*: any*/ ,
                                v42 /*: any*/ ,
                                v43 /*: any*/ ,
                                v45 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v46 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v48 /*: any*/ ,
                                        v115 /*: any*/ ,
                                        v52 /*: any*/ ,
                                        v53 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": [
                                        v46 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v48 /*: any*/ ,
                                        v115 /*: any*/ ,
                                        v52 /*: any*/ 
                                    ]
                                },
                                v55 /*: any*/ ,
                                v60 /*: any*/ ,
                                v62 /*: any*/ ,
                                {
                                    "condition": "includeBylineContributors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "emojiTitlePublished",
                                            "args": v77 /*: any*/ ,
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": v61 /*: any*/ ,
                                            "storageKey": "properties(key:\"emoji-title-published\")"
                                        },
                                        {
                                            "alias": "editorProperty",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "key",
                                                    "value": "editor"
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JsonContentProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v29 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        v38 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "properties(key:\"editor\")"
                                        },
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                v66 /*: any*/ ,
                                                v116 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "homepageId"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v86 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v118 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": v118 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastOwnedBy",
                                                    "plural": false,
                                                    "selections": v118 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v31 /*: any*/ ,
                                                        v79 /*: any*/ ,
                                                        v117 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v87 /*: any*/ ,
                                        v64 /*: any*/ ,
                                        v65 /*: any*/ ,
                                        v68 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeAutomationDiscoveries",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                v116 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeContentHeader",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "condition": "includeFabricEditorEligibility",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "metadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                                            "kind": "LinkedField",
                                                            "name": "frontend",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fabricEditorEligibility"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "contentHash"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "includeContentHeaderAccess",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": v119 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "useNewContentTopper",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v64 /*: any*/ ,
                                        v65 /*: any*/ ,
                                        v67 /*: any*/ ,
                                        v68 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeRestrictions",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v119 /*: any*/ 
                                },
                                {
                                    "condition": "preloadLabels",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v72 /*: any*/ ,
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                v73 /*: any*/ ,
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v113 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        v74 /*: any*/ ,
                                                        v35 /*: any*/ ,
                                                        v75 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeReactions",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v76 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeAudioContent",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v78 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v120 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": v120 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v82 /*: any*/ ,
                                        v83 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeRestrictionAncestors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v84 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v85 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeAgentTrustReceiptData",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v86 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v114 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v87 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeRendererAssetsMedia",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBodyPerRepresentation",
                                            "kind": "LinkedField",
                                            "name": "body",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentBody",
                                                    "kind": "LinkedField",
                                                    "name": "atlas_doc_format",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "EmbeddedMediaToken",
                                                            "kind": "LinkedField",
                                                            "name": "mediaToken",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "token"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isSSR",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "MapOfStringToFormattedBody",
                                            "kind": "LinkedField",
                                            "name": "macroRenderedOutput",
                                            "plural": true,
                                            "selections": [
                                                v41 /*: any*/ ,
                                                {
                                                    "concreteType": "FormattedBody",
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        v56 /*: any*/ ,
                                                        {
                                                            "concreteType": "WebResourceDependencies",
                                                            "kind": "LinkedField",
                                                            "name": "webresource",
                                                            "plural": false,
                                                            "selections": v59 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v88 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "theme",
                            "plural": false,
                            "selections": [
                                v35 /*: any*/ ,
                                v89 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v100 /*: any*/ ,
                                        v103 /*: any*/ ,
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "header",
                                            "plural": false,
                                            "selections": [
                                                v90 /*: any*/ ,
                                                v98 /*: any*/ ,
                                                v99 /*: any*/ ,
                                                v97 /*: any*/ ,
                                                v91 /*: any*/ ,
                                                v92 /*: any*/ ,
                                                v96 /*: any*/ ,
                                                v93 /*: any*/ ,
                                                v95 /*: any*/ ,
                                                v94 /*: any*/ ,
                                                v102 /*: any*/ ,
                                                v101 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "headings",
                                    "plural": true,
                                    "selections": v44 /*: any*/ 
                                }
                            ]
                        },
                        v29 /*: any*/ ,
                        v104 /*: any*/ ,
                        v105 /*: any*/ 
                    ]
                },
                v106 /*: any*/ ,
                v108 /*: any*/ ,
                {
                    "condition": "includeAutohighlights",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "KnowledgeDiscoveryQueryApi",
                            "kind": "LinkedField",
                            "name": "knowledgeDiscovery",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v109 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "keyPhrases",
                                    "plural": false,
                                    "selections": [
                                        v113 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "keyPhrase"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "KnowledgeDiscoveryKeyPhraseConnection"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeAnalyticsByline",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v110 /*: any*/ ,
                            "concreteType": "ContentAnalyticsViewers",
                            "kind": "LinkedField",
                            "name": "contentAnalyticsViewers",
                            "plural": false,
                            "selections": [
                                v73 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "user",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "current",
                                    "value": true
                                }
                            ],
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "confluence_atlassianUser",
                            "plural": false,
                            "selections": [
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceUser",
                                    "kind": "LinkedField",
                                    "name": "confluence",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "permissionType"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "confluence_atlassianUser(current:true)"
                        }
                    ]
                },
                v111 /*: any*/ ,
                {
                    "condition": "includeBylineContributors",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v112 /*: any*/ ,
                            "concreteType": "ContentContributors",
                            "kind": "LinkedField",
                            "name": "contentContributors",
                            "plural": false,
                            "selections": [
                                v73 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isCurrentUserContributor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isOwnerContributor"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": v118 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "286c2a0ccfe96ab3b0fb682ebc3b94a5",
            "id": "d2738c7d165a79a85d7a071def6710f780c53aee70da1e50b6e4616d3070225a",
            "metadata": {},
            "name": "ContentBlogUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentBlogUnifiedQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int,$isSSR:Boolean=false,$includeRendererAssetsMedia:Boolean=false,$includeRendererAssetsDsp:Boolean=false,$rendererAssetsDspAction:DataSecurityPolicyAction=PAGE_EXPORT,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$bylineContributorsLimit:Int,$includeAutomationDiscoveries:Boolean=false,$includeAudioContent:Boolean=false,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false,$includeClassification:Boolean=false,$includeContentHeader:Boolean=false,$includeContentHeaderAccess:Boolean=false,$includeFabricEditorEligibility:Boolean=false,$includeContentHeaderPublicLink:Boolean=false,$includeAnalyticsByline:Boolean=false,$useContentModeFragment:Boolean=false,$includeAutohighlights:Boolean=false,$autohighlightsEntityAri:String,$autohighlightsWorkspaceId:String){mediaConfiguration@include(if:$includeRendererAssetsMedia){clientId,fileStoreUrl},dataSecurityPolicy@include(if:$includeRendererAssetsDsp){isActionEnabledForContent(action:$rendererAssetsDspAction,contentId:$contentId,contentStatus:CURRENT,contentVersion:1,spaceKey:$spaceKey){action,allowed}},...preloadAutohighlightsQuery_query_deyB3@include(if:$includeAutohighlights),...AnalyticsByLine_query_3SK5LQ@include(if:$includeAnalyticsByline),publicLinkPage(pageId:$contentId)@include(if:$includeContentHeaderPublicLink){pageId,pageStatus,accessType},content(id:$contentId,version:$versionOverride){nodes{...ViewPageCommentsPanelPermission_content,id,operations{operation,targetType},type,...PageStatusQueryRelaySpike_content,...PresenterModePortal_content,status,...ArchivedPageBannerV2Status_content,contentProperties{latest{contentMode},draft{contentMode}},...ContentModeFragmentProvider_content@include(if:$useContentModeFragment),contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value},...ContentTitleWithByLine_content_2SjeOj@include(if:$includeBylineContributors)\n      ...useTitleContentPropertiesForPublishedPage_content@include(if:$includeBylineContributors)\n      ...CoverPictureQuery_content@include(if:$includeBylineContributors),...MeetingNotesAutomationDiscoveryFragment_content@include(if:$includeAutomationDiscoveries),title,space{id,name,key,alias},subType,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when,confRev,when@include(if:$includeAgentTrustReceiptData)},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},...ContentHeader_content_118EQH@include(if:$includeContentHeader),metadata{frontend{fabricEditorSupported,embedded,collabService,coverPictureWidth@include(if:$useNewContentTopper)},lastModifiedDate},id@include(if:$useNewContentTopper)\n      pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      pageTitleDraft:properties(key:\"page-title-property-draft\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      metadata@include(if:$useNewContentTopper){frontend{coverPictureWidth}}\n      coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},id@include(if:$includeRestrictions)\n      hasInheritedRestrictions@include(if:$includeRestrictions)\n      hasRestrictions@include(if:$includeRestrictions)\n      hasViewRestrictions@include(if:$includeRestrictions)\n      title@include(if:$includeRestrictions),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n      labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n      contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}\n      ...ReactionsContentFragment_content@include(if:$includeReactions),id@include(if:$includeAudioContent)\n      title@include(if:$includeAudioContent)\n      subType@include(if:$includeAudioContent)\n      emoji:properties(key:\"emoji-title-published\")@include(if:$includeAudioContent){nodes{id,value}}\n      history@include(if:$includeAudioContent){createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}}\n      links@include(if:$includeAudioContent){webui,base}\n      audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"])@include(if:$includeAudioContent){nodes{value,key}}\n      ...AudioContentFragment_content@include(if:$includeAudioContent),id@include(if:$includeRestrictionAncestors)\n      ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},...BylineClassification_content@include(if:$includeClassification)\n      ...useContentClassification_content@include(if:$includeClassification)\n      id@include(if:$includeClassification)\n      classificationLevelDetails@include(if:$includeClassification){classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting},...PageContentRenderer_content,body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n      contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},...ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent@include(if:$includeRendererAssetsMedia),...ViewPageExtensionsAndRendererAssetsContentFragment_content@include(if:$isSSR)}},contentContributors(id:$contentId,limit:$bylineContributorsLimit)@include(if:$includeBylineContributors){...ByLineContributors_contentContributors},space(key:$spaceKey){...ContentHeader_space@include(if:$includeContentHeader),...ContentContainerTheme_space,...ContentTitle_space,...PageContentRenderer_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment AnalyticsByLine_query_3SK5LQ on Query{contentAnalyticsViewers(contentId:$contentId){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}fragment ArchivedPageBannerV2Status_content on Content{id,status}fragment AudioContentFragment_content on Content{id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}fragment ByLineContributors_contentContributors on ContentContributors{count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}}fragment ByLine_content_2SjeOj on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},...RendererContentState_content,pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}}}fragment BylineClassification_content on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content}fragment ContentContainerTheme_space on Space{theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}}}fragment ContentHeader_content_118EQH on Content{id,type,subType,title,status,metadata{lastModifiedDate,frontend{fabricEditorSupported}},...useFabricEligibilityMigrationQuery_content@include(if:$includeFabricEditorEligibility),...ContentTypesHeader_content,...EditContentButton_content,...useShareAndRestrictButtonData_content@include(if:$includeContentHeaderAccess)}fragment ContentHeader_space on Space{id,theme{themeKey}}fragment ContentModeFragmentProvider_content on Content{id,contentProperties{latest{contentMode},draft{contentMode}}}fragment ContentTitleWithByLine_content_2SjeOj on Content{...ContentTitle_content_2SjeOj,...ByLine_content_2SjeOj,...ArchivedPageBannerV2Status_content,...MeetingNotesAutomationDiscoveryFragment_content}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment CoverPictureQuery_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment MeetingNotesAutomationDiscoveryFragment_content on Content{id,title,body{dynamic{value}},metadata{sourceTemplateEntityId}}fragment PageContentRenderer_content on Content{id,title,type,status,version{confRev,number},metadata{lastModifiedDate},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment PageContentRenderer_space on Space{id,theme{themeKey}}fragment PageStatusQueryRelaySpike_content on Content{status}fragment PresenterModePortal_content on Content{title,properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment ReactionsContentFragment_content on Content{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}fragment RendererContentState_content on Content{id,contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value}}fragment ViewPageCommentsPanelPermission_content on Content{id,operations{operation,targetType}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_content on Content{macroRenderedOutput{key,value{value,representation,webresource{tags{js,css}}}}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent on Content{id,body{atlas_doc_format{mediaToken{token}}}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment preloadAutohighlightsQuery_query_deyB3 on Query{knowledgeDiscovery{keyPhrases(entityAri:$autohighlightsEntityAri,workspaceId:$autohighlightsWorkspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}fragment useContentClassification_content on Content{id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useFabricEligibilityMigrationQuery_content on Content{id,metadata{frontend{fabricEditorEligibility,contentHash}}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}fragment useTitleContentPropertiesForPublishedPage_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
        }
    };
}();
$9ba28f7bc5b6ec04$var$node.hash = "41a57e763ce42cd560cc402af7d20892";
var $9ba28f7bc5b6ec04$export$2e2bcd8739ae039 = $9ba28f7bc5b6ec04$var$node;
module.exports["default"] = $9ba28f7bc5b6ec04$export$2e2bcd8739ae039;

});

parcelRegister("jgc4t", function(module, exports) {
/**
 * @generated SignedSource<<b24c35310edbfcaa9ffb87aa66fb1b25>>
 * @relayHash a158b9e8cbd45604175c0716ce285564
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bda9528bc3eb852212db408dd03b1423ddc4a5b56bc2664fe02074a52d742055
const $0d7670aa3e217d31$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "agentSessionsPropertyKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "autohighlightsEntityAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "autohighlightsWorkspaceId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "bylineContributorsLimit"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "fetchAgentSessionsMarker"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAgentTrustReceiptData"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAnalyticsByline"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAudioContent"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAutohighlights"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAutomationDiscoveries"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeBylineContributors"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeClassification"
    }, v13 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentHeader"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentHeaderAccess"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentHeaderPublicLink"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFabricEditorEligibility"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeReactions"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRendererAssetsDsp"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRendererAssetsMedia"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRestrictionAncestors"
    }, v21 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRestrictions"
    }, v22 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSSR"
    }, v23 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "preloadLabels"
    }, v24 = {
        "defaultValue": "PAGE_EXPORT",
        "kind": "LocalArgument",
        "name": "rendererAssetsDspAction"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v26 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useContentModeFragment"
    }, v27 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v28 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v29 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v30 = [
        v29 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v31 = {
        "kind": "ScalarField",
        "name": "id"
    }, v32 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "type"
    }, v34 = {
        "kind": "ScalarField",
        "name": "status"
    }, v35 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v36 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            {
                "concreteType": "DraftContentProperties",
                "kind": "LinkedField",
                "name": "draft",
                "plural": false,
                "selections": v35 /*: any*/ 
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "name"
    }, v38 = {
        "kind": "ScalarField",
        "name": "color"
    }, v39 = {
        "args": [
            {
                "kind": "Literal",
                "name": "isDraft",
                "value": false
            }
        ],
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "contentState",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v37 /*: any*/ ,
            v38 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "restrictionLevel"
            }
        ],
        "storageKey": "contentState(isDraft:false)"
    }, v40 = {
        "kind": "ScalarField",
        "name": "value"
    }, v41 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "USER_FRIENDLY"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "contentStateLastUpdated",
        "plural": false,
        "selections": [
            v40 /*: any*/ 
        ],
        "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
    }, v42 = {
        "kind": "ScalarField",
        "name": "title"
    }, v43 = {
        "kind": "ScalarField",
        "name": "key"
    }, v44 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v37 /*: any*/ ,
            v43 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v45 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v46 = [
        v43 /*: any*/ ,
        v40 /*: any*/ 
    ], v47 = {
        "alias": "smartFolderProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": v46 /*: any*/ 
            }
        ],
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v48 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v49 = {
        "kind": "ScalarField",
        "name": "number"
    }, v50 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v51 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v52 = [
        v51 /*: any*/ 
    ], v53 = {
        "kind": "LinkedField",
        "name": "by",
        "plural": false,
        "selections": v52 /*: any*/ 
    }, v54 = {
        "kind": "ScalarField",
        "name": "when"
    }, v55 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v56 = [
        {
            "kind": "ScalarField",
            "name": "coverPictureWidth"
        }
    ], v57 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "embedded"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "collabService"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v56 /*: any*/ 
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v58 = {
        "kind": "ScalarField",
        "name": "representation"
    }, v59 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            v49 /*: any*/ 
        ]
    }, v60 = {
        "concreteType": "WebResourceTags",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "js"
            },
            {
                "kind": "ScalarField",
                "name": "css"
            }
        ]
    }, v61 = [
        v60 /*: any*/ 
    ], v62 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "dynamic",
                "plural": false,
                "selections": [
                    v58 /*: any*/ ,
                    v40 /*: any*/ ,
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            v31 /*: any*/ ,
                            v59 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "WebResourceDependencies",
                        "kind": "LinkedField",
                        "name": "webresource",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "SuperBatchWebResources",
                                "kind": "LinkedField",
                                "name": "superbatch",
                                "plural": false,
                                "selections": v61 /*: any*/ 
                            },
                            v60 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v63 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v31 /*: any*/ ,
                v43 /*: any*/ ,
                v40 /*: any*/ ,
                v59 /*: any*/ 
            ]
        }
    ], v64 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v63 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v65 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "cover-picture-id-published",
                    "emoji-title-published",
                    "editor",
                    "import-source",
                    "imported-page-modified-date"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v63 /*: any*/ ,
        "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
    }, v66 = {
        "alias": "pageTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "page-title-property-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v63 /*: any*/ ,
        "storageKey": "properties(key:\"page-title-property-published\")"
    }, v67 = {
        "alias": "pageTitleDraft",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "page-title-property-draft"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v63 /*: any*/ ,
        "storageKey": "properties(key:\"page-title-property-draft\")"
    }, v68 = {
        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
        "kind": "LinkedField",
        "name": "frontend",
        "plural": false,
        "selections": v56 /*: any*/ 
    }, v69 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            v68 /*: any*/ 
        ]
    }, v70 = {
        "alias": "coverPictureProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "cover-picture-id-draft",
                    "cover-picture-id-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v63 /*: any*/ ,
        "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
    }, v71 = {
        "kind": "ScalarField",
        "name": "hasInheritedRestrictions"
    }, v72 = {
        "kind": "ScalarField",
        "name": "hasRestrictions"
    }, v73 = {
        "kind": "ScalarField",
        "name": "hasViewRestrictions"
    }, v74 = [
        {
            "kind": "Literal",
            "name": "orderBy",
            "value": {
                "direction": "ASCENDING",
                "sortField": "LABELLING_CREATIONDATE"
            }
        }
    ], v75 = {
        "kind": "ScalarField",
        "name": "count"
    }, v76 = {
        "kind": "ScalarField",
        "name": "label"
    }, v77 = {
        "kind": "ScalarField",
        "name": "prefix"
    }, v78 = {
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "contentReactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    v75 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    },
                    v31 /*: any*/ 
                ]
            }
        ]
    }, v79 = [
        {
            "kind": "Literal",
            "name": "key",
            "value": "emoji-title-published"
        }
    ], v80 = {
        "alias": "emoji",
        "args": v79 /*: any*/ ,
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v31 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v81 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v82 = [
        v51 /*: any*/ ,
        v81 /*: any*/ 
    ], v83 = {
        "kind": "ScalarField",
        "name": "webui"
    }, v84 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            v83 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v85 = {
        "alias": "audioProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v40 /*: any*/ ,
                    v43 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
    }, v86 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v31 /*: any*/ ,
            v42 /*: any*/ ,
            v72 /*: any*/ ,
            {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    v83 /*: any*/ 
                ]
            }
        ]
    }, v87 = {
        "concreteType": "ClassificationLevelDetails",
        "kind": "LinkedField",
        "name": "classificationLevelDetails",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentDataClassificationLevel",
                "kind": "LinkedField",
                "name": "classificationLevel",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "guideline"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "guidelineADF"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v38 /*: any*/ ,
                    v37 /*: any*/ ,
                    v34 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "featureEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "source"
            },
            {
                "kind": "ScalarField",
                "name": "isReclassificationPermitted"
            },
            {
                "kind": "ScalarField",
                "name": "canManageSpaceSettings"
            },
            {
                "kind": "ScalarField",
                "name": "classificationControlSetting"
            },
            {
                "kind": "ScalarField",
                "name": "userOverrideSetting"
            }
        ]
    }, v88 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v89 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v90 = {
        "condition": "fetchAgentSessionsMarker",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "agentSessionsMarker",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "key",
                        "variableName": "agentSessionsPropertyKey"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v63 /*: any*/ 
            }
        ]
    }, v91 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v92 = {
        "kind": "ScalarField",
        "name": "themeKey"
    }, v93 = {
        "kind": "ScalarField",
        "name": "background"
    }, v94 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v95 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v96 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v97 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v98 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v99 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v100 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v101 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v102 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v103 = {
        "concreteType": "ScreenLookAndFeel",
        "kind": "LinkedField",
        "name": "screen",
        "plural": false,
        "selections": [
            v93 /*: any*/ ,
            v94 /*: any*/ ,
            v95 /*: any*/ ,
            v96 /*: any*/ ,
            v97 /*: any*/ ,
            v98 /*: any*/ ,
            v99 /*: any*/ ,
            v100 /*: any*/ ,
            v101 /*: any*/ ,
            v102 /*: any*/ ,
            {
                "concreteType": "LayerScreenLookAndFeel",
                "kind": "LinkedField",
                "name": "layer",
                "plural": false,
                "selections": [
                    v93 /*: any*/ ,
                    v94 /*: any*/ ,
                    v95 /*: any*/ ,
                    v96 /*: any*/ ,
                    v97 /*: any*/ ,
                    v98 /*: any*/ ,
                    v99 /*: any*/ ,
                    v100 /*: any*/ ,
                    v101 /*: any*/ ,
                    v102 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "width"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "height"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "gutterTop"
            },
            {
                "kind": "ScalarField",
                "name": "gutterRight"
            },
            {
                "kind": "ScalarField",
                "name": "gutterBottom"
            },
            {
                "kind": "ScalarField",
                "name": "gutterLeft"
            }
        ]
    }, v104 = {
        "kind": "ScalarField",
        "name": "padding"
    }, v105 = {
        "kind": "ScalarField",
        "name": "borderRadius"
    }, v106 = {
        "concreteType": "ContainerLookAndFeel",
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v93 /*: any*/ ,
            v94 /*: any*/ ,
            v95 /*: any*/ ,
            v96 /*: any*/ ,
            v97 /*: any*/ ,
            v98 /*: any*/ ,
            v99 /*: any*/ ,
            v100 /*: any*/ ,
            v101 /*: any*/ ,
            v102 /*: any*/ ,
            v104 /*: any*/ ,
            v105 /*: any*/ 
        ]
    }, v107 = {
        "concreteType": "SpaceSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "routeOverrideEnabled"
            }
        ]
    }, v108 = {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isAnonymouslyAuthorized"
            }
        ]
    }, v109 = {
        "condition": "includeRendererAssetsMedia",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "MediaConfiguration",
                "kind": "LinkedField",
                "name": "mediaConfiguration",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "clientId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "fileStoreUrl"
                    }
                ]
            }
        ]
    }, v110 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v111 = {
        "condition": "includeRendererAssetsDsp",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Confluence_dataSecurityPolicy",
                "kind": "LinkedField",
                "name": "dataSecurityPolicy",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "action",
                                "variableName": "rendererAssetsDspAction"
                            },
                            v110 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "contentStatus",
                                "value": "CURRENT"
                            },
                            {
                                "kind": "Literal",
                                "name": "contentVersion",
                                "value": 1
                            },
                            {
                                "kind": "Variable",
                                "name": "spaceKey",
                                "variableName": "spaceKey"
                            }
                        ],
                        "concreteType": "DataSecurityPolicyDecision",
                        "kind": "LinkedField",
                        "name": "isActionEnabledForContent",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "action"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "allowed"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v112 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "autohighlightsEntityAri"
        },
        {
            "kind": "Variable",
            "name": "workspaceId",
            "variableName": "autohighlightsWorkspaceId"
        }
    ], v113 = [
        v110 /*: any*/ 
    ], v114 = {
        "condition": "includeContentHeaderPublicLink",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "contentId"
                    }
                ],
                "concreteType": "PublicLinkPage",
                "kind": "LinkedField",
                "name": "publicLinkPage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "pageId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "pageStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accessType"
                    }
                ]
            }
        ]
    }, v115 = [
        v29 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "bylineContributorsLimit"
        }
    ], v116 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v117 = [
        v116 /*: any*/ ,
        v51 /*: any*/ 
    ], v118 = {
        "kind": "LinkedField",
        "name": "by",
        "plural": false,
        "selections": v117 /*: any*/ 
    }, v119 = {
        "kind": "ScalarField",
        "name": "sourceTemplateEntityId"
    }, v120 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v121 = [
        v116 /*: any*/ ,
        v33 /*: any*/ ,
        v51 /*: any*/ ,
        v120 /*: any*/ ,
        v81 /*: any*/ 
    ], v122 = [
        v71 /*: any*/ ,
        v72 /*: any*/ ,
        v73 /*: any*/ 
    ], v123 = [
        v116 /*: any*/ ,
        v51 /*: any*/ ,
        v81 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentUnifiedQuery",
            "selections": [
                {
                    "args": v30 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                v36 /*: any*/ ,
                                v39 /*: any*/ ,
                                v41 /*: any*/ ,
                                v42 /*: any*/ ,
                                v44 /*: any*/ ,
                                v45 /*: any*/ ,
                                v47 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v48 /*: any*/ ,
                                        v49 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v53 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        v55 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": [
                                        v48 /*: any*/ ,
                                        v49 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v53 /*: any*/ ,
                                        v54 /*: any*/ 
                                    ]
                                },
                                v57 /*: any*/ ,
                                v62 /*: any*/ ,
                                v64 /*: any*/ ,
                                v65 /*: any*/ ,
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ViewPageCommentsPanelPermission_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "commentsPanelPermission"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "PageStatusQueryRelaySpike_content"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "PresenterModePortal_content"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ArchivedPageBannerV2Status_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "archivedPageBannerStatusFragment"
                                },
                                {
                                    "condition": "useContentModeFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ContentModeFragmentProvider_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "viewPageContentMode"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeBylineContributors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "useNewContentTopper",
                                                                "variableName": "useNewContentTopper"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "ContentTitleWithByLine_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentTitleWithByLine"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "useTitleContentPropertiesForPublishedPage_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "rendererTitleContentProperties"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "CoverPictureQuery_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "rendererCoverPicture"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeAutomationDiscoveries",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "MeetingNotesAutomationDiscoveryFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "meetingNotesAutomationDiscoveryFragment"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeContentHeader",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "includeAccessButton",
                                                                "variableName": "includeContentHeaderAccess"
                                                            },
                                                            {
                                                                "kind": "Variable",
                                                                "name": "includeFabricEditorEligibility",
                                                                "variableName": "includeFabricEditorEligibility"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "ContentHeader_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentHeaderFragment"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useNewContentTopper",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v31 /*: any*/ ,
                                                    v66 /*: any*/ ,
                                                    v67 /*: any*/ ,
                                                    v69 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "titleContentProperties"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v31 /*: any*/ ,
                                                    v70 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "coverPicture"
                                        },
                                        v66 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeRestrictions",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v31 /*: any*/ ,
                                                    v71 /*: any*/ ,
                                                    v72 /*: any*/ ,
                                                    v73 /*: any*/ ,
                                                    v42 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "shareAndRestrictButtonData"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v31 /*: any*/ ,
                                                    v71 /*: any*/ ,
                                                    v73 /*: any*/ ,
                                                    v72 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "pageRestrictionsContext"
                                        }
                                    ]
                                },
                                {
                                    "condition": "preloadLabels",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ViewPageLabelsContentFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "viewPageLabels"
                                        },
                                        {
                                            "args": v74 /*: any*/ ,
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                v75 /*: any*/ ,
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v31 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v77 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeReactions",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v31 /*: any*/ ,
                                                    v78 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "reactionsContent"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ReactionsContentFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "reactionsContentFragment"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeAudioContent",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v31 /*: any*/ ,
                                                    v42 /*: any*/ ,
                                                    v45 /*: any*/ ,
                                                    v80 /*: any*/ ,
                                                    {
                                                        "concreteType": "History",
                                                        "kind": "LinkedField",
                                                        "name": "history",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "createdBy",
                                                                "plural": false,
                                                                "selections": v82 /*: any*/ 
                                                            },
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "ownedBy",
                                                                "plural": false,
                                                                "selections": v82 /*: any*/ 
                                                            }
                                                        ]
                                                    },
                                                    v84 /*: any*/ ,
                                                    v85 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "audioContent"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "AudioContentFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "audioContentFragment"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeRestrictionAncestors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v31 /*: any*/ ,
                                                    v86 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "pageRestrictionsContextAncestors"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "BylineClassification_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "bylineClassificationFragment"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "useContentClassification_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentClassificationFragment"
                                        },
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v31 /*: any*/ ,
                                                    v87 /*: any*/ 
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentClassification"
                                        }
                                    ]
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PageContentRenderer_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "pageContentRendererFragment"
                                },
                                {
                                    "condition": "includeAgentTrustReceiptData",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v88 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v52 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v89 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeRendererAssetsMedia",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "rendererAssetsMedia"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isSSR",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ViewPageExtensionsAndRendererAssetsContentFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "rendererAssetsMacroOutput"
                                        }
                                    ]
                                },
                                v90 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v91 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeContentHeader",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ContentHeader_space"
                                            }
                                        ],
                                        "type": "Space"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentHeaderFragment"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ContentContainerTheme_space"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ContentTitle_space"
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "PageContentRenderer_space"
                                    }
                                ],
                                "type": "Space"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "pageContentRendererFragment"
                        },
                        v31 /*: any*/ ,
                        {
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "theme",
                            "plural": false,
                            "selections": [
                                v92 /*: any*/ ,
                                v37 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v103 /*: any*/ ,
                                        v106 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v107 /*: any*/ ,
                        v108 /*: any*/ 
                    ]
                },
                v109 /*: any*/ ,
                v111 /*: any*/ ,
                {
                    "condition": "includeAutohighlights",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v112 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "preloadAutohighlightsQuery_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "autohighlightsQueryFragment"
                        }
                    ]
                },
                {
                    "condition": "includeAnalyticsByline",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v113 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "AnalyticsByLine_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "analyticsBylineFragment"
                        }
                    ]
                },
                v114 /*: any*/ ,
                {
                    "condition": "includeBylineContributors",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v115 /*: any*/ ,
                            "concreteType": "ContentContributors",
                            "kind": "LinkedField",
                            "name": "contentContributors",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ByLineContributors_contentContributors"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v25 /*: any*/ ,
                v28 /*: any*/ ,
                v22 /*: any*/ ,
                v19 /*: any*/ ,
                v18 /*: any*/ ,
                v24 /*: any*/ ,
                v27 /*: any*/ ,
                v23 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v11 /*: any*/ ,
                v3 /*: any*/ ,
                v10 /*: any*/ ,
                v8 /*: any*/ ,
                v17 /*: any*/ ,
                v21 /*: any*/ ,
                v20 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v16 /*: any*/ ,
                v15 /*: any*/ ,
                v7 /*: any*/ ,
                v26 /*: any*/ ,
                v9 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentUnifiedQuery",
            "selections": [
                {
                    "args": v30 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                v42 /*: any*/ ,
                                v65 /*: any*/ ,
                                v36 /*: any*/ ,
                                v39 /*: any*/ ,
                                v41 /*: any*/ ,
                                v44 /*: any*/ ,
                                v45 /*: any*/ ,
                                v47 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v48 /*: any*/ ,
                                        v49 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v118 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        v55 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": [
                                        v48 /*: any*/ ,
                                        v49 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v118 /*: any*/ ,
                                        v54 /*: any*/ 
                                    ]
                                },
                                v57 /*: any*/ ,
                                v62 /*: any*/ ,
                                v64 /*: any*/ ,
                                {
                                    "condition": "includeBylineContributors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "emojiTitlePublished",
                                            "args": v79 /*: any*/ ,
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": v63 /*: any*/ ,
                                            "storageKey": "properties(key:\"emoji-title-published\")"
                                        },
                                        {
                                            "alias": "editorProperty",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "key",
                                                    "value": "editor"
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JsonContentProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v31 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v40 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "properties(key:\"editor\")"
                                        },
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                v68 /*: any*/ ,
                                                v119 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "homepageId"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v88 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v121 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": v121 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastOwnedBy",
                                                    "plural": false,
                                                    "selections": v121 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v33 /*: any*/ ,
                                                        v81 /*: any*/ ,
                                                        v120 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v89 /*: any*/ ,
                                        v66 /*: any*/ ,
                                        v67 /*: any*/ ,
                                        v70 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeAutomationDiscoveries",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                v119 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeContentHeader",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "condition": "includeFabricEditorEligibility",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "metadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                                            "kind": "LinkedField",
                                                            "name": "frontend",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fabricEditorEligibility"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "contentHash"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "includeContentHeaderAccess",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": v122 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "useNewContentTopper",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v66 /*: any*/ ,
                                        v67 /*: any*/ ,
                                        v69 /*: any*/ ,
                                        v70 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeRestrictions",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v122 /*: any*/ 
                                },
                                {
                                    "condition": "preloadLabels",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v74 /*: any*/ ,
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                v75 /*: any*/ ,
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v116 /*: any*/ ,
                                                        v31 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v77 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeReactions",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v78 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeAudioContent",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v80 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v123 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": v123 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v84 /*: any*/ ,
                                        v85 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeRestrictionAncestors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v86 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v87 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeAgentTrustReceiptData",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v88 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v117 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v89 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "includeRendererAssetsMedia",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBodyPerRepresentation",
                                            "kind": "LinkedField",
                                            "name": "body",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentBody",
                                                    "kind": "LinkedField",
                                                    "name": "atlas_doc_format",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "EmbeddedMediaToken",
                                                            "kind": "LinkedField",
                                                            "name": "mediaToken",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "token"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isSSR",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "MapOfStringToFormattedBody",
                                            "kind": "LinkedField",
                                            "name": "macroRenderedOutput",
                                            "plural": true,
                                            "selections": [
                                                v43 /*: any*/ ,
                                                {
                                                    "concreteType": "FormattedBody",
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        v40 /*: any*/ ,
                                                        v58 /*: any*/ ,
                                                        {
                                                            "concreteType": "WebResourceDependencies",
                                                            "kind": "LinkedField",
                                                            "name": "webresource",
                                                            "plural": false,
                                                            "selections": v61 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v90 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v91 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "theme",
                            "plural": false,
                            "selections": [
                                v37 /*: any*/ ,
                                v92 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v103 /*: any*/ ,
                                        v106 /*: any*/ ,
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "header",
                                            "plural": false,
                                            "selections": [
                                                v93 /*: any*/ ,
                                                v101 /*: any*/ ,
                                                v102 /*: any*/ ,
                                                v100 /*: any*/ ,
                                                v94 /*: any*/ ,
                                                v95 /*: any*/ ,
                                                v99 /*: any*/ ,
                                                v96 /*: any*/ ,
                                                v98 /*: any*/ ,
                                                v97 /*: any*/ ,
                                                v105 /*: any*/ ,
                                                v104 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "headings",
                                    "plural": true,
                                    "selections": v46 /*: any*/ 
                                }
                            ]
                        },
                        v31 /*: any*/ ,
                        v107 /*: any*/ ,
                        v108 /*: any*/ 
                    ]
                },
                v109 /*: any*/ ,
                v111 /*: any*/ ,
                {
                    "condition": "includeAutohighlights",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "KnowledgeDiscoveryQueryApi",
                            "kind": "LinkedField",
                            "name": "knowledgeDiscovery",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v112 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "keyPhrases",
                                    "plural": false,
                                    "selections": [
                                        v116 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "keyPhrase"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "KnowledgeDiscoveryKeyPhraseConnection"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeAnalyticsByline",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v113 /*: any*/ ,
                            "concreteType": "ContentAnalyticsViewers",
                            "kind": "LinkedField",
                            "name": "contentAnalyticsViewers",
                            "plural": false,
                            "selections": [
                                v75 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "user",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "current",
                                    "value": true
                                }
                            ],
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "confluence_atlassianUser",
                            "plural": false,
                            "selections": [
                                v31 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceUser",
                                    "kind": "LinkedField",
                                    "name": "confluence",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "permissionType"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "confluence_atlassianUser(current:true)"
                        }
                    ]
                },
                v114 /*: any*/ ,
                {
                    "condition": "includeBylineContributors",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v115 /*: any*/ ,
                            "concreteType": "ContentContributors",
                            "kind": "LinkedField",
                            "name": "contentContributors",
                            "plural": false,
                            "selections": [
                                v75 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isCurrentUserContributor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isOwnerContributor"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": v121 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a158b9e8cbd45604175c0716ce285564",
            "id": "bda9528bc3eb852212db408dd03b1423ddc4a5b56bc2664fe02074a52d742055",
            "metadata": {},
            "name": "ContentUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentUnifiedQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int,$isSSR:Boolean=false,$includeRendererAssetsMedia:Boolean=false,$includeRendererAssetsDsp:Boolean=false,$rendererAssetsDspAction:DataSecurityPolicyAction=PAGE_EXPORT,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$agentSessionsPropertyKey:String=\"\",$fetchAgentSessionsMarker:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$bylineContributorsLimit:Int,$includeAutomationDiscoveries:Boolean=false,$includeAudioContent:Boolean=false,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false,$includeClassification:Boolean=false,$includeContentHeader:Boolean=false,$includeContentHeaderAccess:Boolean=false,$includeFabricEditorEligibility:Boolean=false,$includeContentHeaderPublicLink:Boolean=false,$includeAnalyticsByline:Boolean=false,$useContentModeFragment:Boolean=false,$includeAutohighlights:Boolean=false,$autohighlightsEntityAri:String,$autohighlightsWorkspaceId:String)@allowHigherTimeout{mediaConfiguration@include(if:$includeRendererAssetsMedia){clientId,fileStoreUrl},dataSecurityPolicy@include(if:$includeRendererAssetsDsp){isActionEnabledForContent(action:$rendererAssetsDspAction,contentId:$contentId,contentStatus:CURRENT,contentVersion:1,spaceKey:$spaceKey){action,allowed}},...preloadAutohighlightsQuery_query_deyB3@include(if:$includeAutohighlights),...AnalyticsByLine_query_3SK5LQ@include(if:$includeAnalyticsByline),publicLinkPage(pageId:$contentId)@include(if:$includeContentHeaderPublicLink){pageId,pageStatus,accessType},content(id:$contentId,version:$versionOverride){nodes{...ViewPageCommentsPanelPermission_content,id,operations{operation,targetType},type,...PageStatusQueryRelaySpike_content,...PresenterModePortal_content,status,...ArchivedPageBannerV2Status_content,contentProperties{latest{contentMode},draft{contentMode}},...ContentModeFragmentProvider_content@include(if:$useContentModeFragment),contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value},...ContentTitleWithByLine_content_2SjeOj@include(if:$includeBylineContributors)\n      ...useTitleContentPropertiesForPublishedPage_content@include(if:$includeBylineContributors)\n      ...CoverPictureQuery_content@include(if:$includeBylineContributors),...MeetingNotesAutomationDiscoveryFragment_content@include(if:$includeAutomationDiscoveries),title,space{id,name,key,alias},subType,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when,confRev,when@include(if:$includeAgentTrustReceiptData)},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},...ContentHeader_content_118EQH@include(if:$includeContentHeader),metadata{frontend{fabricEditorSupported,embedded,collabService,coverPictureWidth@include(if:$useNewContentTopper)},lastModifiedDate},id@include(if:$useNewContentTopper)\n      pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      pageTitleDraft:properties(key:\"page-title-property-draft\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      metadata@include(if:$useNewContentTopper){frontend{coverPictureWidth}}\n      coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},id@include(if:$includeRestrictions)\n      hasInheritedRestrictions@include(if:$includeRestrictions)\n      hasRestrictions@include(if:$includeRestrictions)\n      hasViewRestrictions@include(if:$includeRestrictions)\n      title@include(if:$includeRestrictions),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n      labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n      contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}\n      ...ReactionsContentFragment_content@include(if:$includeReactions),id@include(if:$includeAudioContent)\n      title@include(if:$includeAudioContent)\n      subType@include(if:$includeAudioContent)\n      emoji:properties(key:\"emoji-title-published\")@include(if:$includeAudioContent){nodes{id,value}}\n      history@include(if:$includeAudioContent){createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}}\n      links@include(if:$includeAudioContent){webui,base}\n      audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"])@include(if:$includeAudioContent){nodes{value,key}}\n      ...AudioContentFragment_content@include(if:$includeAudioContent),id@include(if:$includeRestrictionAncestors)\n      ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},...BylineClassification_content@include(if:$includeClassification)\n      ...useContentClassification_content@include(if:$includeClassification)\n      id@include(if:$includeClassification)\n      classificationLevelDetails@include(if:$includeClassification){classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting},...PageContentRenderer_content,body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n      contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},...ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent@include(if:$includeRendererAssetsMedia),...ViewPageExtensionsAndRendererAssetsContentFragment_content@include(if:$isSSR),agentSessionsMarker:properties(key:$agentSessionsPropertyKey)@include(if:$fetchAgentSessionsMarker){nodes{id,key,value,version{number}}}}},contentContributors(id:$contentId,limit:$bylineContributorsLimit)@include(if:$includeBylineContributors){...ByLineContributors_contentContributors},space(key:$spaceKey){...ContentHeader_space@include(if:$includeContentHeader),...ContentContainerTheme_space,...ContentTitle_space,...PageContentRenderer_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment AnalyticsByLine_query_3SK5LQ on Query{contentAnalyticsViewers(contentId:$contentId){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}fragment ArchivedPageBannerV2Status_content on Content{id,status}fragment AudioContentFragment_content on Content{id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}fragment ByLineContributors_contentContributors on ContentContributors{count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}}fragment ByLine_content_2SjeOj on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},...RendererContentState_content,pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}}}fragment BylineClassification_content on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content}fragment ContentContainerTheme_space on Space{theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}}}fragment ContentHeader_content_118EQH on Content{id,type,subType,title,status,metadata{lastModifiedDate,frontend{fabricEditorSupported}},...useFabricEligibilityMigrationQuery_content@include(if:$includeFabricEditorEligibility),...ContentTypesHeader_content,...EditContentButton_content,...useShareAndRestrictButtonData_content@include(if:$includeContentHeaderAccess)}fragment ContentHeader_space on Space{id,theme{themeKey}}fragment ContentModeFragmentProvider_content on Content{id,contentProperties{latest{contentMode},draft{contentMode}}}fragment ContentTitleWithByLine_content_2SjeOj on Content{...ContentTitle_content_2SjeOj,...ByLine_content_2SjeOj,...ArchivedPageBannerV2Status_content,...MeetingNotesAutomationDiscoveryFragment_content}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment CoverPictureQuery_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment MeetingNotesAutomationDiscoveryFragment_content on Content{id,title,body{dynamic{value}},metadata{sourceTemplateEntityId}}fragment PageContentRenderer_content on Content{id,title,type,status,version{confRev,number},metadata{lastModifiedDate},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment PageContentRenderer_space on Space{id,theme{themeKey}}fragment PageStatusQueryRelaySpike_content on Content{status}fragment PresenterModePortal_content on Content{title,properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment ReactionsContentFragment_content on Content{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}fragment RendererContentState_content on Content{id,contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value}}fragment ViewPageCommentsPanelPermission_content on Content{id,operations{operation,targetType}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_content on Content{macroRenderedOutput{key,value{value,representation,webresource{tags{js,css}}}}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent on Content{id,body{atlas_doc_format{mediaToken{token}}}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment preloadAutohighlightsQuery_query_deyB3 on Query{knowledgeDiscovery{keyPhrases(entityAri:$autohighlightsEntityAri,workspaceId:$autohighlightsWorkspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}fragment useContentClassification_content on Content{id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useFabricEligibilityMigrationQuery_content on Content{id,metadata{frontend{fabricEditorEligibility,contentHash}}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}fragment useTitleContentPropertiesForPublishedPage_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
        }
    };
}();
$0d7670aa3e217d31$var$node.hash = "cc4d08378d47b3bf4b276867b3fc27a4";
var $0d7670aa3e217d31$export$2e2bcd8739ae039 = $0d7670aa3e217d31$var$node;
module.exports["default"] = $0d7670aa3e217d31$export$2e2bcd8739ae039;

});


$parcel$global.rlb("a7sEM")
//# sourceMappingURL=CommentsPanelWrapper.c20418c3.js.map
